<template>
  <b-container fluid>
    <b-row v-if="showServiceMessage">
        <b-col lg="12" md="12" sm="12" class="text-left">
            <iq-card style="border: 1px solid var(--color-light-ddd-gray);
                        border-left: 5px solid var(--iq-warning-dark);
                        box-shadow: 0 1px 5px rgb(34 34 34 / 20%);">
                <div class="m-2">
                    <div class="alert-danger text-center">
                        <strong>{{ $t('externalUser.permission_denied') }}</strong>&nbsp;
                        "{{this.serviceUrl.patientPanelCurrentServiceName}}" {{ $t('externalUser.not_allowed') }} | &nbsp;
                        <span class="text-dark">
                            <b>{{ $t('externalUser.permission_denied_note') }}</b>
                        </span>
                    </div>
                </div>
            </iq-card>
        </b-col>
    </b-row>
    <b-row >
    <b-col lg="12" sm="12" md="12" xl="12">
        <iq-card>
            <b-row>
                <b-col md='10' class="mt-5 mb-5" style="border:1px solid gray" offset-md = 1>
                    <template>
                        <b-overlay :show="loading">
                            <b-row>
                                <b-col xs="12" sm="12" class=" mt-3 text-left">
                                    <b-button variant="primary" @click="pdfExport">
                                        {{  $t('globalTrans.export_pdf') }}
                                    </b-button>
                                    <p class="badge badge-warning ml-2 mr-2" style="color:black;" v-if="!isSubmitted">{{ $t('externalUser.not_submitted') }}</p>
                                    <p class="badge badge-warning ml-2 mr-2" style="color:green;" v-if="isSubmitted && applicationStatus === 2">{{ $t('externalUser.in_progress') }}</p>
                                    <p class="badge badge-success ml-2 mr-2" v-if="isSubmitted && applicationStatus === 3">{{ $t('globalTrans.active') }}</p>
                                    <p class="badge badge-danger ml-2 mr-2" v-if="isSubmitted && applicationStatus === 0">{{ $t('globalTrans.inactive') }}</p>
                                    <p class="badge badge-warning ml-2 mr-2" style="color:black;" v-if="isSubmitted && applicationStatus === 1">{{ $t('globalTrans.pending') }}</p>
                                    <p class="badge badge-danger ml-2 mr-2" v-if="isSubmitted && applicationStatus === 4">{{ $t('globalTrans.rejected') }}</p>
                                </b-col>
                                <b-col>
                                    <hr />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12" class="text-center mb-4">
                                    <h5 class='complain-title'>{{ $t('externalUser.profile_details') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="3" sm="12">
                                    <b-img class="mb-2" style='width:150px;height:180px' @error="imageLoadError()" fluid :src="profile.photo"  alt="Right image"></b-img>
                                </b-col>
                                <b-col lg="9" sm="12">
                                    <table class="table table-sm table-striped table-hover">
                                        <tbody>
                                            <tr>
                                                <th>{{$t('retailerManagement.name')}}</th>
                                                <th>:</th>
                                                <th>{{ i18 ? profile.name_bn : profile.name }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{$t('externalUser.mobile_no')}}</th>
                                                <th>:</th>
                                                <th>{{ i18 ? '০' : '0' }}{{ $n(profile.mobile, { useGrouping: false }) }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{$t('externalUser.father_name')}}</th>
                                                <th>:</th>
                                                <th>{{ i18 ? profile.father_name_bn : profile.father_name }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{$t('externalUser.mother_name')}}</th>
                                                <th>:</th>
                                                <th>{{ i18 ? profile.mother_name_bn : profile.mother_name }}</th>
                                            </tr>
                                            <tr v-if="profile.nid">
                                                <th>{{$t('retailerManagement.nid')}}</th>
                                                <th>:</th>
                                                <th>{{ profile.nid }}</th>
                                            </tr>
                                            <tr v-if="profile.birth_id">
                                                <th>{{$t('externalUser.birth_id')}}</th>
                                                <th>:</th>
                                                <th>{{ profile.birth_id }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{$t('externalUser.dss_id')}} </th>
                                                <th>:</th>
                                                <th>{{ profile.dss_id }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{$t('production_service_config.reg_date')}} </th>
                                                <th>:</th>
                                                <th>{{ profile.registration_date | dateFormat }}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12" class="text-center mb-4">
                                    <h5 class='complain-title'>{{ $t('externalUser.present_address') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12">
                                    <b-table-simple striped bordered small hover>
                                        <b-tbody>
                                            <b-tr>
                                                <b-th>{{$t('org_pro.area_type')}}</b-th>
                                                <b-th>{{ getStoreData('wardTypeList', profile.address.pr_area_type_id) }}</b-th>
                                                <b-th>{{ $t('retailerManagement.division')}}</b-th>
                                                <b-th>{{ getStoreData('divisionList', profile.address.pr_division_id) }}</b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{$t('retailerManagement.district')}}</b-th>
                                                <b-th>{{ getStoreData('districtList', profile.address.pr_district_id) }}</b-th>
                                                <slot  v-if="profile.address.pr_area_type_id === 1">
                                                    <b-th>{{$t('production_service_config.city_corporation_id')}}</b-th>
                                                    <b-th>{{ getStoreData('cityCorporationList', profile.address.pr_city_corporation_id) }}</b-th>
                                                </slot>
                                                <slot v-if="profile.address.pr_area_type_id === 2">
                                                    <b-th>{{$t('org_pro.pauroshoba')}}</b-th>
                                                    <b-th>{{ getStoreData('pauroshobaList', profile.address.pr_paurasabha_id) }}</b-th>
                                                </slot>
                                                <slot v-if="profile.address.pr_area_type_id === 3">
                                                    <b-th>{{$t('retailerManagement.upazilla')}}</b-th>
                                                    <b-th>{{ getStoreData('upazilaList', profile.address.pr_upazila_id) }}</b-th>
                                                </slot>
                                            </b-tr>
                                            <b-tr>
                                                <slot v-if="profile.address.pr_area_type_id === 2">
                                                    <b-th>{{$t('retailerManagement.upazilla')}}</b-th>
                                                    <b-th>{{ getStoreData('upazilaList', profile.address.pr_upazila_id) }}</b-th>
                                                </slot>
                                                <slot v-if="profile.address.pr_area_type_id === 3">
                                                    <b-th>{{$t('org_pro_union.union')}}</b-th>
                                                    <b-th>{{ getStoreData('unionList', profile.address.pr_union_id) }}</b-th>
                                                </slot>
                                                <slot>
                                                    <b-th>{{$t('org_pro.ward')}}</b-th>
                                                    <b-th>{{ getStoreData('wardList', profile.address.pr_ward_id) }}</b-th>
                                                </slot>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{$t('externalUser.post_code')}}</b-th>
                                                <b-th>{{ profile.address.pr_post_code? profile.address.pr_post_code : '' }}</b-th>
                                                <b-th>{{$t('externalUser.post_office')}}</b-th>
                                                <b-th>{{ profile.address.pr_post_office }}</b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{$t('production_service_config.address')}}</b-th>
                                                <b-th colspan="3">{{ i18 ? profile.address.pr_address_bn : profile.address.pr_address_en }}</b-th>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12" class="text-center mb-4">
                                    <h5 class='complain-title'>{{ $t('externalUser.permanent_address') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12">
                                    <b-table-simple striped bordered small hover>
                                        <b-tbody>
                                            <b-tr>
                                                <b-th>{{$t('org_pro.area_type')}}</b-th>
                                                <b-th>{{ getStoreData('wardTypeList', profile.address.pm_area_type_id) }}</b-th>
                                                <b-th>{{ $t('retailerManagement.division')}}</b-th>
                                                <b-th>{{ getStoreData('divisionList', profile.address.pm_division_id) }}</b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{$t('retailerManagement.district')}}</b-th>
                                                <b-th>{{ getStoreData('districtList', profile.address.pm_district_id) }}</b-th>
                                                <slot  v-if="profile.address.pm_area_type_id === 1">
                                                    <b-th>{{$t('production_service_config.city_corporation_id')}}</b-th>
                                                    <b-th>{{ getStoreData('cityCorporationList', profile.address.pm_city_corporation_id) }}</b-th>
                                                </slot>
                                                <slot v-if="profile.address.pm_area_type_id === 2">
                                                    <b-th>{{$t('org_pro.pauroshoba')}}</b-th>
                                                    <b-th>{{ getStoreData('pauroshobaList', profile.address.pm_paurasabha_id) }}</b-th>
                                                </slot>
                                                <slot v-if="profile.address.pm_area_type_id === 3">
                                                    <b-th>{{$t('retailerManagement.upazilla')}}</b-th>
                                                    <b-th>{{ getStoreData('upazilaList', profile.address.pm_upazila_id) }}</b-th>
                                                </slot>
                                            </b-tr>
                                            <b-tr>
                                                <slot v-if="profile.address.pm_area_type_id === 2">
                                                    <b-th>{{$t('retailerManagement.upazilla')}}</b-th>
                                                    <b-th>{{ getStoreData('upazilaList', profile.address.pm_upazila_id) }}</b-th>
                                                </slot>
                                                <slot v-if="profile.address.pm_area_type_id === 3">
                                                    <b-th>{{$t('org_pro_union.union')}}</b-th>
                                                    <b-th>{{ getStoreData('unionList', profile.address.pm_union_id) }}</b-th>
                                                </slot>
                                                <slot>
                                                    <b-th>{{$t('org_pro.ward')}}</b-th>
                                                    <b-th>{{ getStoreData('wardList', profile.address.pm_ward_id) }}</b-th>
                                                </slot>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{$t('externalUser.post_code')}}</b-th>
                                                <b-th>{{ profile.address.pm_post_code }}</b-th>
                                                <b-th>{{$t('externalUser.post_office')}}</b-th>
                                                <b-th>{{ profile.address.pm_post_office }}</b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{$t('production_service_config.address')}}</b-th>
                                                <b-th colspan="3">{{ i18 ? profile.address.pm_address_bn : profile.address.pm_address_en }}</b-th>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                            <!-- center details -->
                            <b-row>
                                <b-col lg="12" sm="12" class="text-center mb-4">
                                    <h5 class='complain-title'>{{ $t('externalUser.service_center') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" sm="12">
                                    <b-table-simple striped bordered small hover>
                                        <b-tbody>
                                            <b-tr>
                                                <b-th>{{ $t('externalUser.center')}}</b-th>
                                                <b-th>{{ getPatientStoreData('centerList', profile.center_id) }}</b-th>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                            <b-row class="p-3">
                                <b-col class="text-right">
                                    <p class="badge badge-warning ml-2 mr-2" style="color:black;" v-if="!isSubmitted">{{ $t('externalUser.not_submitted') }}</p>
                                    <p class="badge badge-warning ml-2 mr-2" style="color:green;" v-if="isSubmitted && applicationStatus === 2">{{ $t('externalUser.in_progress') }}</p>
                                    <p class="badge badge-success ml-2 mr-2" v-if="isSubmitted && applicationStatus === 3">{{ $t('globalTrans.active') }}</p>
                                    <p class="badge badge-danger ml-2 mr-2" v-if="isSubmitted && applicationStatus === 0">{{ $t('globalTrans.inactive') }}</p>
                                    <p class="badge badge-warning ml-2 mr-2" style="color:black;" v-if="isSubmitted && applicationStatus === 1">{{ $t('globalTrans.pending') }}</p>
                                    <p class="badge badge-danger ml-2 mr-2" v-if="isSubmitted && applicationStatus === 4">{{ $t('globalTrans.rejected') }}</p>

                                    <p v-if="profile.save_status === 2" class="badge badge-success" style="margin-right: 15px;">{{ $t('globalTrans.finalSave') }} &nbsp; </p>
                                    <router-link v-else to="/patient-panel/profile-edit" class="btn btn-success mr-2"><i class="ri-edit-line"></i> {{ $t('nav.user.profileEditTitle') }}</router-link>
                                    <b-button v-if="isSubmitted && applicationStatus === 3" v-b-modal.modal-3 variant=" iq-bg-success mr-1 mb-1" size="sm" :title="$t('nav.user.centerChangeTitle')" @click="edit(profile)"><i class="ri-edit-line"></i>{{ $t('nav.user.centerChangeTitle') }}</b-button>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </b-col>
            </b-row>
        </iq-card>
    </b-col>
    </b-row>
    <b-modal id="modal-3" size="lg" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
    <p>
    <ChangeCenter :id="editItemId" :key="editItemId" :item="item"/>
    </p>
    </b-modal>
  </b-container>
</template>
<script>
import ChangeCenter from './ChangeCenterForm'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { profileShow } from '../../api/routes'
import ExportPdf from './export-pdf_details'
import { mapGetters } from 'vuex'

export default {
    created () {
        this.getPatientData()
    },
    components: {
        ChangeCenter
    },
    data () {
        return {
            isSubmitted: false,
            applicationStatus: 0,
            showServiceMessage: false,
            otherServiceMassage: '',
            profile: '',
            saveBtnName: this.$t('globalTrans.save'),
            editItemId: 0,
            item: []
        }
    },
    computed: {
        ...mapGetters({
        serviceUrl: 'Portal/serviceUrl',
        currentPanel: 'ExternalUser/getActivePanel',
        authUser: 'Auth/authUser'
        }),
        formTitle () {
            return this.$t('nav.user.centerChangeTitle')
        },
        loading () {
            return this.$store.state.ExternalUser.static.loading
        },
        i18 () {
            return (this.$i18n.locale === 'bn') ? 1 : 0
        },
        ...mapGetters({
            panelObj: 'ExternalUser/panelObj'
        })
    },
    methods: {
        checkOtherServices () {
            const serviceUrl = this.serviceUrl.patientPanelCurrentServiceUrl
            if (serviceUrl !== '' && this.applicationStatus !== 3) {
                this.showServiceMessage = true
                setTimeout(() => {
                    this.$store.dispatch('Portal/setServiceUrl', {
                        patientPanelCurrentServiceUrl: '',
                        patientPanelCurrentServiceName: ''
                    })
                    this.showServiceMessage = false
                }, 50000)
            }
        },
        edit (item) {
            this.editItemId = item.user_id
            this.item = item
        },
        imageLoadError () {
            this.profile.photo = '/images/user.jpg'
        },
        setLoad (load) {
            this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: load })
        },
        async getPatientData () {
            this.setLoad(true)
            const result = await RestApi.getData(awarenessEventServiceBaseUrl, profileShow)
            this.setLoad(false)
            if (result.success) {
                if (result.data.save_status === 2) {
                    this.isSubmitted = true
                }
                this.applicationStatus = result.data.status
                let photo = '/images/user.jpg'
                if (result.data.photo) {
                    photo = awarenessEventServiceBaseUrl + 'download-attachment?file=app/public' + result.data.photo
                }
                this.profile = Object.assign({}, result.data, {
                    photo: photo
                })
                this.checkOtherServices()
            } else {
                this.$router.push('/patient-panel/profile-edit')
            }
        },
        getBase64Image (img) {
            var canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            var dataURL = canvas.toDataURL('image/png')
            return dataURL.replace(/^data:image\/(png|jpg)base64,/, '')
        },
        pdfExport () {
            const reportTitle = this.$t('production_service_config.dealer_info')
            ExportPdf.exportPdfDetails(reportTitle, this.profile, this)
        },
        getStoreData (state, Id) {
            if (state) {
                const tmpData = this.$store.state.ExternalUser.commonObj[state]
                if (typeof tmpData === 'undefined') {
                    return ''
                } else {
                    const data = tmpData.find(item => item.value === Id)
                    if (this.$i18n.locale === 'bn') {
                        if (typeof data === 'undefined') {
                            return ''
                        } else {
                            return data.text_bn
                        }
                    } else {
                        if (typeof data === 'undefined') {
                            return ''
                        } else {
                            return data.text
                        }
                    }
                    // if (typeof data === 'undefined') {
                    //     return ''
                    // } else {
                    //     return data.text
                    // }
                }
            }
        },
        getPatientStoreData (state, Id) {
            if (state) {
                const tmpData = this.$store.state.ExternalUser.patientCommonObj[state]
                if (typeof tmpData === 'undefined') {
                    return ''
                } else {
                    const data = tmpData.find(item => item.value === Id)
                    if (typeof data === 'undefined') {
                        return ''
                    } else {
                        if (this.$i18n.locale === 'bn') {
                            return data.text_bn
                        } else {
                            return data.text_en
                        }
                    }
                }
            }
        }
    }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
